module.exports = __webpack_public_path__ + "67705ea1820edd679ac84966ed463a8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Splash/images/slides/slide4.jpg
// module id = ./src/views/Splash/images/slides/slide4.jpg
// module chunks = 0